import React from 'react';
import { HeroSection } from './components/sections/HeroSection';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { PainPointsSection } from './components/sections/PainPointsSection';
import { TomosSection } from './components/sections/TomosSection';
import { ComparisonSection } from './components/sections/ComparisonSection';
import { BonusesSection } from './components/sections/BonusesSection';
import { PurchaseSection } from './components/sections/PurchaseSection';
import { PostresSection } from './components/sections/PostresSection';
import { GuaranteeSection } from './components/sections/GuaranteeSection';
import { FaqSection } from './components/sections/FaqSection';
import { CostSection } from './components/sections/CostSection';
import { FooterOfferSection } from './components/sections/FooterOfferSection';
import { SalesPopup } from './components/SalesPopup';
export function App() {
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-orange-500 selection:text-white" data-id="element-0">
      {/* Facebook Pixel */}
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=3123699361155808&ev=PageView&noscript=1" alt="" data-id="element-1" />

      <SalesPopup data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <TestimonialsSection data-id="element-5" />
        <PurchaseSection id="oferta-testimonios" data-id="element-6" />
        <PainPointsSection data-id="element-7" />
        <TomosSection data-id="element-8" />
        <ComparisonSection data-id="element-9" />
        <BonusesSection data-id="element-10" />
        <PurchaseSection data-id="element-11" />
        <PostresSection data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <FaqSection data-id="element-14" />
        <CostSection data-id="element-15" />
        <FooterOfferSection data-id="element-16" />
      </main>
    </div>;
}